var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Header',{attrs:{"appLinks":_vm.links,"appTitle":_vm.title,"appId":_vm.appId,"documentationUrl":_vm.documentationUrl,"mailToAddress":_vm.mailToAddress,"isLoggedIn":true,"onLogInClicked":() => {},"onLogOutClicked":_vm.onLogOutClicked,"profile":_vm.profile,"responsive":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }